import React from 'react';

import { RateShopperPageComponent } from './components/rate-shopper-page';
import { RateShopperContextProvider } from './context/rate-shopper-context';
import ErrorBoundary from '../../../components/error-boundary';
import { SystemAutomationContextProvider } from '../../../contexts/system-automation-context';

export const RateShopperPage = () => {
  return (
    <ErrorBoundary errorMessageId='rateShopperPage'>
      <SystemAutomationContextProvider>
        <RateShopperContextProvider>
          <RateShopperPageComponent />
        </RateShopperContextProvider>
      </SystemAutomationContextProvider>
    </ErrorBoundary>
  );
};
